export default __webpack_public_path__ + "icon_smartphone.34555721d43c37a236c57257d7125fc4.svg";